import ApiService from '@/service/api.service.js'
import types from './mutation-types'

export const getProducts = ({ commit }) => {
  commit(types.FETCH_PRODUCTS_PENDING)
  ApiService.getProducts()
    .then((res) => {
      if (res.error) {
        commit(types.FETCH_PRODUCTS_FAILURE)
      } else {
        commit(types.LOAD_PRODUCTS, res.data)
        commit(types.FETCH_PRODUCTS_SUCCESS)
      }
    })
    .catch((err) => {
      commit(types.FETCH_PRODUCTS_FAILURE)
      console.error(err)
    })
}

export const getProductsSearch = (context, params) => {
  context.commit(types.FETCH_PRODUCTS_PENDING)
  context.commit(types.UPDATE_PARAMS, params)
  ApiService.getProductsSearch(context.state.filterParams)
    .then((res) => {
      if (res.error) {
        context.commit(types.FETCH_PRODUCTS_FAILURE)
      } else {
        context.commit(types.LOAD_PRODUCTS_TMP, res.data)
        context.commit(types.FETCH_PRODUCTS_SUCCESS)
      }
    })
    .catch((err) => {
      context.commit(types.FETCH_PRODUCTS_FAILURE)
      console.error(err)
    })
}

export const setDateList = async (context, params) => {
  await context.commit(types.SET_DATELIST, params)
}

export const setSelectedDate = async (context, params) => {
  await context.commit(types.SET_SELECTED_DATE, params)
}

export const setDeletedProduct = (context, productId) => {
  context.commit(types.SET_DELETED_PRODUCT, productId)
}
